// GDMCOMMENT: Latitudes and longitudes used in this file are either sourced from GrabPlaces, GrabMaps, OSM or randomly created by the developer and are not obtained from other external sources.

// example order v2 model
// this.order = {
//   'name-sender': { value: 'Sender' }, // form field
//   'phone-sender': { value: '1111111' }, // form field
//   'cod-sender': { value: 1111111 }, // form field
//   'name-recipient-0': { value: 'Recipient 0' }, // form field
//   'phone-recipient-0': { value: '2222222' }, // form field
//   'cod-recipient-0': { value: 2222222 }, // form field
//   [FIELD_NAME.SERVICE_TYPE]: {
//     name: 'serviceType',
//     dirty: false,
//     value: '82',
//   }, // form field
//   [FIELD_NAME.PAYMENT_METHOD]: { value: CASH_BY_SENDER }, // form field
//   senderLocation: {
//     address: {
//       name: '1060 Tỉnh Lộ 15',
//       combined_address:
//         '1060, Tỉnh Lộ 15, Tân Thạnh Tây, Củ Chi, Hồ Chí Minh, Ho Chi Minh, 700000',
//       combined_city:
//         'Tân Thạnh Tây, Củ Chi, Ho Chi Minh, Ho Chi Minh, Hồ Chí Minh',
//       house: '1060',
//       street: 'Tỉnh Lộ 15',
//       city: 'Ho Chi Minh',
//       state: 'Hồ Chí Minh',
//       country: 'Vietnam',
//       country_id: 5,
//     },
//     latlng: {
//       latitude: 10.985349,
//       longitude: 106.575809,
//     },
//     appear_hours: '{}',
//     grabtaxi: {
//       city_id: '9',
//     },
//     icon:
//       'https://s3-ap-southeast-1.amazonaws.com/myteksi/production/uploads/poi_type/residential.png',
//     id: 'IT.2R2P2MZZNEJ21',
//     metadata: {
//       api: 'search|search',
//       poi_timestamp: '2020-11-28T03:56:43Z',
//       region: 'Ho Chi Minh',
//       source: 'internal-top-v2',
//     },
//     opening_hours: '{}',
//     rating:
//       'ac_rank = 0, ac_score = 0, cg_rank = 0, cg_score = 0, d = 0, d2 = 0, d2_raw = 9.377291781406779, d_raw = 0, es_rank = 0, es_score = 203.84251, h = 0, h2 = 0, h2_raw = 0, h_raw = 0, p = 0, pf = 0, ph = 0, ph_rank = 0, ph_raw = 0, ph_score = 0, provider_ln_raw = 3.4011973816621555, provider_ln_score = 0, provider_rank = 0, provider_score = 203.84251, provider_sigmoid_score = 0, r = 0, r_raw = 0, s = 0.9887277372811303, s2 = 0, s2_raw = 1, s_raw = 1, t = 0, t_raw = 0',
//     score: 0.9887277372811303,
//     type: 'residential',
//   },
//   recipientLocations: [
//     {
//       address: {
//         name: '19 Lê Thị Riêng - 19 Le Thi Rieng',
//         combined_address:
//           '19B, Le Thi Rieng, HoChiMinh, Ho Chi Minh, 700000',
//         combined_city: 'Ho Chi Minh, HoChiMinh',
//         house: '19B',
//         street: 'Le Thi Rieng',
//         city: 'Ho Chi Minh',
//         state: 'HoChiMinh',
//         country: 'Vietnam',
//         country_id: 5,
//       },
//       latlng: {
//         latitude: 10.7713,
//         longitude: 106.692,
//       },
//       grabtaxi: {
//         city_id: '9',
//       },
//       icon:
//         'https://s3-ap-southeast-1.amazonaws.com/myteksi/production/uploads/poi_type/utilities.png',
//       id: 'IT.2ILHPWST6AXWS',
//       metadata: {
//         api: 'search|search',
//         poi_timestamp: '2020-11-28T03:58:12Z',
//         region: 'Ho Chi Minh',
//         source: 'internal-top-v2',
//       },
//       opening_hours: '{}',
//       rating:
//         'ac_rank = 0, ac_score = 0, cg_rank = 0, cg_score = 0, d = 0, d2 = 0, d2_raw = 9.378476441386976, d_raw = 0, es_rank = 0, es_score = 522.6632, h = 0, h2 = 0, h2_raw = 0, h_raw = 0, p = 0, pf = 0, ph = 0, ph_rank = 0, ph_raw = 0, ph_score = 0, provider_ln_raw = 3.4011973816621555, provider_ln_score = 0, provider_rank = 0, provider_score = 522.6632, provider_sigmoid_score = 0, r = 0, r_raw = 0, s = 0.9887277372811303, s2 = 0, s2_raw = 0.8750000000000001, s_raw = 1, t = 0, t_raw = 0',
//       score: 0.9887277372811303,
//       type: 'utilities',
//     },
//   ],
//   // serviceTypes transformed by transformServiceTypes in booking-selectors
//   serviceTypes: [
//     {
//       ID: 82,
//       name: 'Giao Hàng',
//       expressServiceID: 0,
//       iconName: 'icon-1453983830.png',
//       allowCash: true,
//       allowCard: true,
//       windowTime: {
//         from: '0001-01-01 00:00:00 +0000 UTC',
//         to: '0001-01-01 23:59:59 +0000 UTC',
//       },
//     },
//     {
//       ID: 5907,
//       name: 'Giao Hàng Công Ty - COD',
//       expressServiceID: 1,
//       iconName: '',
//       allowCash: true,
//       allowCard: true,
//       windowTime: {
//         from: '0001-01-01 00:00:00 +0000 UTC',
//         to: '0001-01-01 23:59:59 +0000 UTC',
//       },
//     },
//     {
//       ID: 6484,
//       name: 'Giao Hàng Công Ty',
//       expressServiceID: 0,
//       iconName: 'icon-1536897319.png',
//       allowCash: true,
//       allowCard: true,
//       windowTime: {
//         from: '0001-01-01 00:00:00 +0000 UTC',
//         to: '0001-01-01 23:59:59 +0000 UTC',
//       },
//     },
//     {
//       ID: 4095,
//       name: 'Giao Hàng Công Ty - Ứng tiền <500k',
//       expressServiceID: 0,
//       iconName: 'icon-1525428799.png',
//       allowCash: true,
//       allowCard: false,
//       windowTime: {
//         from: '0001-01-01 00:00:00 +0000 UTC',
//         to: '0001-01-01 23:59:59 +0000 UTC',
//       },
//     },
//   ],
// };

export default class BookingModel {
  constructor(state) {
    this.createdOrders = [];
    this.quotes = {};
    this.promoQuotes = {};
    this.addressTranslate = {};
    this.addressSearch = {};
    this.serviceTypes = [];

    // v2 - contain all service types, key by city_id
    this.serviceTypeMap = {};
    // v2 - single order
    this.order = {};
    // v2 - bulk order, array of single order
    this.orders = [];

    // v2
    this.bulkUploadProcessing = {
      uploadingExcel: false,
    };
  }
}
